module.exports = "/assets/data/402ac6f3825cd664a61759d4c0b3cfac-NE26.data.json";